import BaseFormPresenter from "../../base/BaseFormPresenter";

class ExitFormPagePresenter extends BaseFormPresenter {
  constructor(
    view,
    upsertUseCase,
    getObjectUseCase,
    findObjectUseCase,
    deleteObjectUseCase
  ) {
    super();
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.getObjectUseCase = getObjectUseCase;
    this.findObjectUseCase = findObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  componentDidMount() {
    this.init();
    this.getObject();
    this.getEmployeeDetails();
  }

  async getEmployeeDetails() {
    const user = this.view.getCurrentUser();
    const userId = user?.employee?.id;
    try {
      const object = await this.getObjectUseCase.execute("employees", userId);

      this.view.setState({ employeeDetails: object });

      return object;
    } catch (error) {
      console.error("Failed to fetch employee details: ", error);
    }
  }

  async onSubmitForm(object) {
    const collection = this.view.getCollectionName();

    try {
      this.view.showLoading();
      const employeeDetails = await this.getEmployeeDetails();

      const exitFormObject = await this.upsertUseCase.execute(
        collection,
        object
      );

      const updatedDetails = {
        ...employeeDetails,
        coordinator: { id: employeeDetails?.coordinator?.id },
        applicant: { id: employeeDetails?.applicant?.id },
        recruiter: { id: employeeDetails?.recruiter?.id },
        exit_interview: { id: exitFormObject?.id },
      };

      const updateEmployee = await this.upsertUseCase.execute(
        "employees",
        updatedDetails
      );

      if (object?.id) {
        this.view.showSuccessSnackbar("Successfully saved!");
      } else {
        this.view.showSuccessSnackbar("Successfully updated!");
      }

      this.view.hideLoading();
    } catch (error) {
      console.error("Failed to submit object: ", error);
    }
  }
}

export default ExitFormPagePresenter;
